export default __webpack_public_path__ + "static/media/gallery_02.0e3604ea.jpg";